// npm install isomorphic-dompurify and then import
import DOMPurify from "isomorphic-dompurify";
export const cleanHtml = (htmlContent) => {
  return DOMPurify.sanitize(htmlContent);
};
